import { useEffect } from 'react';
import { useLocalObservable } from 'mobx-react-lite';
import { runInAction } from 'mobx';
import type { AccountService } from '@/models/account/types';
import { fetchAccountServices } from '@/models/account/service';

export function useServicesData(idAccount: string | undefined) {
  const store = useLocalObservable(() => ({
    items: [] as AccountService[],
    isLoading: false,
    error: null as string | null,
  }));

  useEffect(() => {
    if (!idAccount) return;
    runInAction(() => {
      store.isLoading = true;
      store.error = null;
    });
    fetchAccountServices(idAccount)
      .then((services) =>
        runInAction(() => {
          store.items = services;
          store.isLoading = false;
        })
      )
      .catch((err: Error) =>
        runInAction(() => {
          store.error = err.message;
          store.isLoading = false;
        })
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps, @eslint-react/exhaustive-deps
  }, [idAccount]);

  function reload() {
    if (!idAccount) return;
    void fetchAccountServices(idAccount).then((services) =>
      runInAction(() => {
        store.items = services;
      })
    );
  }

  function applyLocalStatus(idCamera: string, newStatus: '0' | '1') {
    runInAction(() => {
      const cam = store.items.find((s) => s.id_camera === idCamera);
      if (cam) cam.status = newStatus;
    });
  }

  return {
    get items() {
      return store.items;
    },
    get isLoading() {
      return store.isLoading;
    },
    get error() {
      return store.error;
    },
    reload,
    applyLocalStatus,
  };
}

export type ServicesData = ReturnType<typeof useServicesData>;
